import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { EventNames } from "core/monitoring/types/enums";
import { trackEvents } from "core/monitoring/Events";
import { WisdomAIComingSoon } from "../components/WisdomAIComingSoon";

export const WISDOM_AI_PATH = "/wisdom-ai";

export const isWisdomAIEnabled = () => process.env.REACT_APP_USE_WISDOM_AI === "true";

export const useWisdomAIEntry = () => {
  const navigate = useNavigate();
  const [isComingSoonOpen, setIsComingSoonOpen] = useState(false);

  const enterWisdomAI = () => {
    trackEvents(EventNames.WISDOM_AI_CLICK);
    if (isWisdomAIEnabled()) {
      navigate(WISDOM_AI_PATH);
      return;
    }
    trackEvents(EventNames.WISDOM_AI_COMING_SOON_VIEWED);
    setIsComingSoonOpen(true);
  };

  const comingSoon = <WisdomAIComingSoon isOpen={isComingSoonOpen} onClose={() => setIsComingSoonOpen(false)} />;

  return { enterWisdomAI, comingSoon };
};
